module.exports = __webpack_public_path__ + "images/puzzle/Skeleton/PNG/Piece02.dd8a20f46d3d6698b1757ec837eee54b.png";